<template>
  <div>
    <b-alert
      v-if="!selectedOption && !loading && !hasSelectableOptions && options.length === 0"
      variant="warning"
      show
      class="p-50 text-center"
    >
      {{ $t('schedule.no-available-employee') }}
    </b-alert>

    <v-select
      v-else
      :value="selectedOption"
      :options="options"
      append-to-body
      :get-option-label="getAvailabilityOptionLabel"
      :selectable="isSelectableOption"
      :clearable="!!selectedOption"
      :searchable="true"
      :placeholder="hasSelectableOptions ? $t('schedule.select-employee') : $t('schedule.no-available-employee')"
      :class="{
        'schedule-availability-select': true,
        'mt-50': true,
        'schedule-availability-select--selected': !!selectedOption,
        'schedule-availability-select--no-options': !selectedOption && !hasSelectableOptions,
      }"
      @input="handleInput"
    >
      <template #option="option">
        <div class="availability-option d-flex align-items-center justify-content-between">
          <span :class="isFallbackOption(option) ? 'text-warning' : ''">
            {{ option.user.surname }} {{ option.user.name }}
          </span>
          <feather-icon
            v-if="isFallbackOption(option)"
            v-b-tooltip.hover
            :title="$t('schedule.planner.fallback-no-availability-warning')"
            icon="AlertTriangleIcon"
            size="14"
            class="text-warning"
          />
        </div>
      </template>
      <template #selected-option="option">
        <div class="availability-option d-flex align-items-center">
          <span class="text-success">
            {{ option.user.surname }} {{ option.user.name }}
          </span>
          <feather-icon
            v-if="isFallbackOption(option)"
            v-b-tooltip.hover
            :title="$t('schedule.planner.fallback-no-availability-warning')"
            icon="AlertTriangleIcon"
            size="14"
            class="text-warning ml-50"
          />
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: { vSelect },
  props: {
    selectedOption: {
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    hasSelectableOptions: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    function isFallbackOption(option) {
      return Boolean(
        option?.isFallbackWithoutAvailability
        || option?.isPlannedWithoutAvailability
        || option?.shift?.isPlannedWithoutAvailability,
      )
    }

    function isSelectableOption(option) {
      return !option?.shift
    }

    function getAvailabilityOptionLabel(option) {
      return `${option?.user?.surname || ''} ${option?.user?.name || ''}`.trim()
    }

    function handleInput(value) {
      if (props.selectedOption) {
        if (value === null) {
          emit('clear', props.selectedOption)
        } else if (value !== props.selectedOption) {
          emit('change', { from: props.selectedOption, to: value })
        }
        return
      }
      if (value) {
        emit('select', value)
      }
    }

    return {
      isFallbackOption,
      isSelectableOption,
      getAvailabilityOptionLabel,
      handleInput,
    }
  },
}
</script>

<style scoped lang="scss">
.availability-option {
  width: 100%;
}

::v-deep .schedule-availability-select--no-options .vs__search,
::v-deep .schedule-availability-select--no-options .vs__search::placeholder {
  color: #ea5455 !important;
  opacity: 1;
}

::v-deep .schedule-availability-select--no-options .vs__dropdown-toggle {
  border-color: #ea5455 !important;
}

::v-deep .schedule-availability-select .vs__dropdown-menu {
  z-index: 3000;
}
</style>
